module.exports = __webpack_public_path__ + "img/swiper2.de9951f5.png";